import { render, staticRenderFns } from "./TransformationsModal.vue?vue&type=template&id=2b0d3650"
import script from "./TransformationsModal.vue?vue&type=script&lang=js"
export * from "./TransformationsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports